export const timeZones = {
  EU: [
    'Europe/Paris',
    'Europe/Berlin',
    'Europe/Madrid',
    'Europe/Rome',
    'Europe/Brussels',
    'Europe/Vienna',
    'Europe/Stockholm',
    'Europe/Zurich',
    'Europe/Warsaw',
    'Europe/Prague',
    'Europe/Copenhagen',
    'Europe/Luxembourg',
    'Europe/Amsterdam',
    'Europe/Bratislava',
    'Europe/Budapest',
    'Europe/Ljubljana',
    'Europe/Malta',
    'Europe/Vilnius',
    'Europe/Riga',
    'Europe/Tallinn',
    'Europe/Helsinki',
    'Europe/Athens',
    'Europe/Sofia',
    'Europe/Bucharest',
    'Europe/Nicosia',
    'Europe/Lisbon',
    'Atlantic/Canary',
    'Atlantic/Faroe',
    'Atlantic/Madeira'
  ],
  UK: [
    'Europe/London',
    'Atlantic/Bermuda',
    'Atlantic/Stanley',
    'Atlantic/South_Georgia',
    'Atlantic/St_Helena',
    'Indian/Chagos',
    'America/Cayman',
    'Europe/Gibraltar',
    'America/Montserrat',
    'Pacific/Pitcairn',
    'Atlantic/St_Helena',
    'Atlantic/South_Georgia',
    'America/Grand_Turk',
    'Europe/Guernsey',
    'Europe/Jersey',
    'Europe/Isle_of_Man'
  ],
  US: [
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'America/Anchorage',
    'Pacific/Honolulu',
    'America/Phoenix',
    'America/Indiana/Indianapolis',
    'America/Indiana/Marengo',
    'America/Indiana/Vevay',
    'America/Detroit',
    'America/Kentucky/Louisville',
    'America/Kentucky/Monticello',
    'America/Puerto_Rico',
    'Pacific/Pago_Pago',
    'Pacific/Guam',
    'Pacific/Wake',
    'Pacific/Midway',
    'Pacific/Johnston'
  ],
  IND: ['Asia/Kolkata', 'Asia/Calcutta'],
  CA: [
    'America/Toronto',
    'America/Vancouver',
    'America/Edmonton',
    'America/Winnipeg',
    'America/Halifax',
    'America/St_Johns',
    'America/Regina',
    'America/Whitehorse',
    'America/Yellowknife',
    'America/Dawson',
    'America/Dawson_Creek',
    'America/Inuvik',
    'America/Moncton',
    'America/Glace_Bay',
    'America/Goose_Bay',
    'America/Blanc-Sablon',
    'America/Montreal',
    'America/Thunder_Bay',
    'America/Iqaluit',
    'America/Rankin_Inlet',
    'America/Resolute',
    'America/Cambridge_Bay',
    'America/Creston',
    'America/Fort_Nelson'
  ],
  AU: [
    'Australia/Sydney',
    'Australia/Melbourne',
    'Australia/Brisbane',
    'Australia/Perth',
    'Australia/Adelaide',
    'Australia/Darwin',
    'Australia/Hobart',
    'Australia/Canberra',
    'Australia/Lord_Howe',
    'Australia/Eucla',
    'Australia/Broken_Hill',
    'Australia/Lindeman',
    'Australia/Macquarie'
  ],
  NZ: ['Pacific/Auckland', 'Pacific/Chatham', 'Pacific/Wellington', 'Pacific/Chatham'],
  SA: ['Asia/Riyadh'],
  UAE: ['Asia/Dubai'],
  SG: ['Asia/Singapore'],
  JP: ['Asia/Tokyo'],
  KR: ['Asia/Seoul']
}
